export default __webpack_public_path__ + "26b2b6d70fe42c1847c80b2edfea068b.svg";